import template from './infoIcon.html';

export const infoIconComponent = {
  name: 'infoIcon',
  restrict: 'E',
  template,
  controllerAs: 'vm',
  controller: function ($element, envService) {
    'ngInject';
    this.$onInit = function () {};
  },
  bindings: {
    translation: '@',
  },
};
